import {
  REQUEST_LOCATIONS,
  RECEIVE_LOCATIONS,
  REQUEST_FEATURED_LOCATIONS,
  RECEIVE_FEATURED_LOCATIONS
} from '../actions/constants';

export default function locations(
  state = {
    loadingAll: false,
    loadingFeatured: false,
    moreLocations: false,
    locations: [],
    featuredLocations: []
  }, action
) {
  switch (action.type) {
    case REQUEST_LOCATIONS:
      return Object.assign({}, state, {
        loadingAll: true
    })
    case RECEIVE_LOCATIONS:
      return Object.assign({}, state, {
        loadingAll: false,
        locations: action.locations
    })
    case REQUEST_FEATURED_LOCATIONS:
      return Object.assign({}, state, {
        loadingFeatured: true
    })
    case RECEIVE_FEATURED_LOCATIONS:
      return Object.assign({}, state, {
        loadingFeatured: false,
        featuredLocations: action.featured.featuredLocations,
        showMoreLocations: action.featured.showMoreLocations
    })
    default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/locationsReducer.js